const SearchCMS = {
    searchInputPlaceholder: "search.searchInputPlaceholder",
    emptySearchInputHeadline: "search.emptySearchInputHeadline",
    noResultsSearchText: "search.noResultsSearchText",
    noResultsSearchTextQuery: "search.noResultsSearchTextQuery",
    noResultsHeadline: "search.noResultsHeadline",
    noResultsDidYouMean: "search.noResultsDidYouMean",
    searchInputWithQueryHeadline: "search.searchInputWithQueryHeadline",
    paginationResults: "search.paginationResults",
    showMoreButton: "search.showMoreButton",
    trendingItemsHeadline: "search.trendingItemsHeadline",
};

export default SearchCMS;
